import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="py-10 sm:py-12" style={{ backgroundColor: '#FAFAF9', borderTop: '1px solid #e8e4da' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-5">
        <Link to="/" className="flex items-center gap-3 min-w-0">
          <Logo size={36} />
          <div className="min-w-0">
            <p className="font-serif text-base sm:text-lg" style={{ color: '#130F28' }}>Crush Marketing</p>
            <p className="text-xs" style={{ color: '#4a4566' }}>Managed marketing for growth-minded businesses</p>
          </div>
        </Link>
        <div className="flex flex-wrap items-center gap-4 sm:gap-6 text-xs sm:text-sm" style={{ color: '#3b3656' }}>
          <Link
            to="/about"
            data-testid="footer-about-link"
            className="hover:text-[#5132d4] transition-colors focus:outline-none focus:ring-2 focus:ring-[#6B4BEF] rounded"
          >
            About
          </Link>
          <a href="#" className="hover:text-[#5132d4] transition-colors focus:outline-none focus:ring-2 focus:ring-[#6B4BEF] rounded">Terms</a>
          <a href="#" className="hover:text-[#5132d4] transition-colors focus:outline-none focus:ring-2 focus:ring-[#6B4BEF] rounded">Privacy</a>
          <span>© {new Date().getFullYear()} Crush Marketing</span>
        </div>
      </div>
    </footer>
  );
}
